import { createZodTranslationProvider } from '@bos/form';

import { useI18nContext } from '../../locale/i18n-react';

export const ZodTranslationProvider = createZodTranslationProvider({
	useErrorMessages: () => ({
		required: useI18nContext().LL.zod.requiredField(),
	}),
	useDefaultErrorMessage: () => useI18nContext().LL.common.invalidFormat(),
});
